import { Container, injectable } from 'inversify'
import 'reflect-metadata'

import { watch } from 'vue';


import MyApolloClient from '../../../../common/infrastructure/funciones/HelperApolloClient';

import { IDataSourceServiceRepository } from '../domain/IDataSourceServiceRepository';

import { GET_ALL_DATASOURCE, GET_DATASOURCE_BY_ID } from './query/dataSourceQuery';
import ApolloConst from '../../../../common/domain/constantes/Apollo/ApolloConst';
import { IapDataSourceDataBase } from "../domain/iapDataSourceDataBase";
import { IapDataSourceField } from "../domain/iapDataSourceField";
import { IapDataSourceService } from "../domain/iapDataSourceService";
import { IapDataSourceTableAlias } from '../domain/iapDataSourceTableAlias';
import { CALL_WS_SOAP, CLASS_FROM_SWAGGER_URL, CLASS_FROM_WSDL_URL } from './mutation/dataSourceServiceMutation';
import HelperUtils from '../../../../common/infrastructure/funciones/HelperUtils';
import { WSDL } from '../domain/wsdl';
import { Swagger } from '../domain/swagger';



@injectable()
export class DataSourceServiceApolloClientRepository implements IDataSourceServiceRepository {
  private apolloClient: MyApolloClient
  private clientId: String
  constructor(apolloInstance: MyApolloClient, clientId = ApolloConst.DEFAULT) {
    this.apolloClient = apolloInstance
    this.clientId = clientId
  }

   async update(dataInput: IapDataSourceService): (Promise<IapDataSourceService>) {
     return new Promise<IapDataSourceService>(async (resolve, reject) => {
   /*    const result = this.apolloClient.executeQuery(UPDATE, { data: dataInput }, this.clientId)
 
       watch(result, (value: any) => {
 
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceMutation.update)
         }
         catch (e) {
           reject()
         }
       });
 */
     });
   }
 
   async delete(dataSourceServiceId: number): (Promise<boolean>) {
     return new Promise<boolean>(async (resolve, reject) => {
   /*    const result = this.apolloClient.executeQuery(DELETE, { dataSourceServiceId: dataSourceServiceId }, this.clientId)
 
       watch(result, (value: any) => {
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceMutation.deleteDataSource)
         }
         catch (e) {
           reject()
         }
       });*/
     });
   }
 
 
 
 
   async add(dataInput: IapDataSourceService): (Promise<IapDataSourceService>) {
     return new Promise<IapDataSourceService>(async (resolve, reject) => {
     /*  const result = this.apolloClient.executeQuery(ADD, { data: dataInput, tables: tables, db: db, srv: srv, fields: fields }, this.clientId)
 
       watch(result, (value: any) => {
 
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceMutation.add)
         }
         catch (e) {
           reject()
         }
       });
 */
     });
   }
 
   async modify(dataInput: IapDataSourceService, tables: IapDataSourceTableAlias[], db: IapDataSourceDataBase, srv: IapDataSourceService, fields: IapDataSourceField[]): (Promise<IapDataSourceService>) {
     return new Promise<IapDataSourceService>(async (resolve, reject) => {
      /* const result = this.apolloClient.executeQuery(MODIFY, { data: dataInput, tables: tables, db: db, srv: srv, fields: fields }, this.clientId)
 
       watch(result, (value: any) => {
 
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceMutation.modify)
         }
         catch (e) {
           reject()
         }
       });
 */
     });
   }
 
 
   async refreshFields(dataInput: IapDataSourceService): (Promise<IapDataSourceService>) {
     return new Promise<IapDataSourceService>(async (resolve, reject) => {
      /* const result = this.apolloClient.executeQuery(REFRESH_FIELDS, { data: dataInput }, this.clientId)
 
       watch(result, (value: any) => {
 
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceMutation.refreshFields)
         }
         catch (e) {
           reject()
         }
       });
 */
     });
   }
 
   async getAll(applicationId: number, applicationVersion: number): (Promise<IapDataSourceService[]>) {
     return new Promise<IapDataSourceService[]>(async (resolve, reject) => {
       const result = this.apolloClient.executeQuery(GET_ALL_DATASOURCE, { applicationId: applicationId, applicationVersion: applicationVersion }, this.clientId)
 
       watch(result, (value: any) => {
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceQuery.getAll)
         }
         catch (e) {
           reject()
         }
       });
     });
   }
 
   async getById(applicationId: number, applicationVersion: number, datasourceId: number): (Promise<IapDataSourceService>) {
     return new Promise<IapDataSourceService>(async (resolve, reject) => {
       const result = this.apolloClient.executeQuery(GET_DATASOURCE_BY_ID, { applicationId: applicationId, applicationVersion: applicationVersion, datasourceId: datasourceId }, this.clientId)
 
       watch(result, (value: any) => {
         try {
           HelperUtils.handleDatesApollo(value)
           resolve(value.dataSourceQuery.getById)
         }
         catch (e) {
           reject()
         }
       });
     });
   }
 
  async classFromWsdlUrl(applicationId: number, applicationVersion: number, dataSourceId: number, url: string): (Promise<WSDL>) {
    return new Promise<WSDL>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(CLASS_FROM_WSDL_URL, { applicationId: applicationId, applicationVersion: applicationVersion, dataSourceId: dataSourceId, url: url }, this.clientId)

      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value)
          resolve(value.dataSourceServiceMutation.classFromWsdlUrl)
        }
        catch (e) {
          reject()
        }
      });
    });
  }

  async classFromSwaggerUrl(applicationId: number, applicationVersion: number, dataSourceId: number, url: string): (Promise<Swagger>) {
    return new Promise<Swagger>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(CLASS_FROM_SWAGGER_URL, { applicationId: applicationId, applicationVersion: applicationVersion, dataSourceId: dataSourceId, url: url }, this.clientId)

      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value)
          resolve(value.dataSourceServiceMutation.classFromSwaggerUrl)
        }
        catch (e) {
          reject()
        }
      });
    });
  }

  async callWebServiceSOAP(applicationId: number, applicationVersion: number, dataSourceId: number, url: string, method: string, request: string): (Promise<string>) {
    return new Promise<string>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(CALL_WS_SOAP, { applicationId: applicationId, applicationVersion: applicationVersion, dataSourceId: dataSourceId, url: url, method: method, request: request }, this.clientId)
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value)
          resolve(value.dataSourceServiceMutation.callWebServiceSOAP)
        }
        catch (e) {
          reject()
        }
      });
    });
  }

}
